<div [bbValueDiff]="newValue">
  {{ oldValue }}
</div>
